import Base, {
    updateOptions, updateQuantities, createCarousel, updateAvailability, getAttributesHtml, processSwatchValues,
} from '@assets/product/base';
import Resource from '@assets/utils/resource';

export function processNonSwatchValues(attr, $productContainer) {
    const $attr = `[data-attr="${attr.id}"]`;
    const $defaultOption = $productContainer.find(`${$attr} .select-${attr.id} option:first`);
    $defaultOption.attr('value', attr.resetUrl);
    attr.values.forEach((attrValue) => {
        const $attrValue = $productContainer
            .find(`${$attr} [data-attr-value="${attrValue.value}"]`);
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');
        if (!Resource.getSitePreference('storefront', 'isNonShoppable')) {
            if (attrValue.inStockLabel) {
                $attrValue.attr('data-stock-message-label', attrValue.inStockLabel);
            } else {
                $attrValue.removeAttr('data-stock-message-label');
            }

            if (!attrValue.selectable) {
                $attrValue.attr('disabled', true);
            }
        }
    });
}

export function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    const attrsWithSwatches = ['color'];

    attrs.forEach((attr) => {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

export function handleVariantResponse(response, $productContainer) {
    const isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    let isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    const primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        const $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        const $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer,
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer,
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

export function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        if ($productContainer.data('truncatedPrice')) {
            // this if statement is added to use truncatePrice in Product-Variation
            // to make it work add data-truncated-price="true" to the div $productContainer
            // at the moment is used for pdp(MB) and it is avoiding propagation in wishlist and cart
            // eslint-disable-next-line no-param-reassign
            selectedValueUrl += '&truncatedPrice=true';
        }
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer },
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success(data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data, container: $productContainer },
                );
                $.spinner().stop();
            },
            error() {
                $.spinner().stop();
            },
        });
    }
}

export default class extends Base {
    constructor() {
        super();
        this.attributeSelect = attributeSelect;
    }

    colorAttribute() {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            let $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    }

    selectAttribute() {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            let $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    }

    availability() {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            let $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect(
                    $(e.currentTarget).find('option:selected').data('url'),
                    $productContainer,
                );
            }
        });
    }
}
